import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { IUser } from 'src/app/core/models/IUser';
import { IUserPermission } from 'src/app/core/models/IUserPermission';
import { AuthService } from 'src/app/core/services/auth.service';

@Directive({
    selector: '[isinrole]',
    standalone: false
})
export class IsinroleDirective implements OnInit {
  private hasView = false;

  constructor(private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService) { }

  @Input() isinrole: string;

  ngOnInit() {
    let user: IUser = this.authService.getLoggedInUser();

    if ((user && user.employeePermissions) && user.employeePermissions.some((x: IUserPermission) => x.perClassType === this.isinrole)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
    else {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
